// src/pages/SubcodonProfile/components/BatchOutputOptions.jsx
import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Tooltip } from "react-tooltip";

const BatchOutputOptions = ({
  csvCheck,
  htmlCheck,
  onUpdateCsvCheck,
  onUpdateHtmlCheck,
}) => {
  const InfoTooltip = ({ id, content }) => (
    <>
      <AiOutlineInfoCircle
        data-tooltip-id={id}
        title={content}
        style={{
          marginLeft: "4px",
          cursor: "help",
          color: "#6B7280",
          fontSize: "16px",
          verticalAlign: "middle",
          display: "inline-flex",
          alignItems: "center",
        }}
      />
    </>
  );

  return (
    <Card
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "1px",
        height: "100%",
        minHeight: "200px",
      }}
    >
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <h5
            className="mb-0 fw-semibold d-flex align-items-center"
            style={{ color: "#1a6d51" }}
          >
            <i className="ri-download-2-line me-2"></i>
            Output Options{" "}
          </h5>
        </div>
      </CardHeader>
      <CardBody className="py-3">
        <div className="mb-3">
          <h6 className="text-muted mb-3">Select output formats:</h6>

          <Row>
            <Col md={6}>
              <div
                style={{
                  border: `2px solid ${csvCheck ? "#1A6D51" : "#e5e7eb"}`,
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: csvCheck ? "#f0fdf4" : "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onClick={() => onUpdateCsvCheck(!csvCheck)}
              >
                <FormGroup check className="mb-0">
                  <Input
                    type="checkbox"
                    checked={csvCheck}
                    onChange={(e) => onUpdateCsvCheck(e.target.checked)}
                    id="csvCheck"
                    style={{
                      transform: "scale(1.2)",
                      accentColor: "#1A6D51",
                    }}
                  />
                  <Label
                    check
                    for="csvCheck"
                    className="d-flex align-items-center"
                  >
                    <div className="ms-2">
                      <div className="fw-semibold text-dark">
                        CSV Files
                        <InfoTooltip
                          id="tt-csv-output"
                          content="Generate CSV files containing the plot data for further analysis in Excel or other tools."
                        />
                      </div>
                      <small className="text-muted">
                        Data tables in spreadsheet format
                      </small>
                    </div>
                  </Label>
                </FormGroup>
              </div>
            </Col>

            <Col md={6}>
              <div
                style={{
                  border: `2px solid ${htmlCheck ? "#1A6D51" : "#e5e7eb"}`,
                  borderRadius: "8px",
                  padding: "16px",
                  backgroundColor: htmlCheck ? "#f0fdf4" : "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onClick={() => onUpdateHtmlCheck(!htmlCheck)}
              >
                <FormGroup check className="mb-0">
                  <Input
                    type="checkbox"
                    checked={htmlCheck}
                    onChange={(e) => onUpdateHtmlCheck(e.target.checked)}
                    id="htmlCheck"
                    style={{
                      transform: "scale(1.2)",
                      accentColor: "#1A6D51",
                    }}
                  />
                  <Label
                    check
                    for="htmlCheck"
                    className="d-flex align-items-center"
                  >
                    <div className="ms-2">
                      <div className="fw-semibold text-dark">
                        HTML Plot
                        <InfoTooltip
                          id="tt-html-output"
                          content="Generate interactive HTML plots that can be viewed in any web browser."
                        />
                      </div>
                      <small className="text-muted">
                        Interactive plots in web format
                      </small>
                    </div>
                  </Label>
                </FormGroup>
              </div>
            </Col>
          </Row>
        </div>

        {!csvCheck && !htmlCheck && (
          <div className="alert alert-warning py-2 px-3 mb-0">
            <i className="ri-alert-line me-2"></i>
            <small>Please select at least one output format</small>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default BatchOutputOptions;
